import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=40088719&scoped=true&"
import script from "./LandingLayout.vue?vue&type=script&lang=ts&"
export * from "./LandingLayout.vue?vue&type=script&lang=ts&"
import style0 from "./LandingLayout.vue?vue&type=style&index=0&id=40088719&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40088719",
  null
  
)

export default component.exports